import { useState } from 'react';
import { useLocation } from 'react-router';
import { useIsReferralRebuildEnabled } from '~/hooks/useIsReferralRebuildEnabled';

/** The legacy (v1) link's query param, as `useReferralHandler` reads it. */
const LEGACY_REFERRAL_QUERY_PARAM = 'referral';

/**
 * Whether to show `LegacyReferralLinkToast`: the app opened on a legacy
 * `?referral=` link while the rebuild is on.
 *
 * The param is read once, at mount — a signed-out office is redirected to the
 * login page, which drops the query string before the flag may have loaded.
 * Called from `App`, which outlives the switch between the signed-out and
 * signed-in trees, so the notice shows once per page load, not once per tree.
 */
export const useLegacyReferralLinkNotice = () => {
  const { search } = useLocation();
  const isReferralRebuildEnabled = useIsReferralRebuildEnabled();
  const [openedOnLegacyLink] = useState(() =>
    new URLSearchParams(search).has(LEGACY_REFERRAL_QUERY_PARAM),
  );
  const [isDismissed, setIsDismissed] = useState(false);

  return {
    isOpen: openedOnLegacyLink && isReferralRebuildEnabled && !isDismissed,
    close: () => setIsDismissed(true),
  };
};
